import {JsonObject} from "@angular-devkit/core";

export interface WorkflowComponent {
  formData(type?): JsonObject;
  initData(dataId:number,workflowInfo:WorkflowInfo): void;
  valid(type?): any;
}
export class WorkflowInfo {
  workflowId: number;
  workflowName: string;
  editAble: boolean;
  customData:object;
  constructor(workflowId: number,workflowName: string,editAble: boolean,customData:object){
    this.workflowId = workflowId;
    this.workflowName = workflowName;
    this.editAble = editAble;
    this.customData = customData;
  }

}
